import { defineStore } from 'pinia';

export const useMenuStore = defineStore('menu', {
    state () {
        return {
            // todo: this will likely end up being a multidimensional menu
            menu: [
                { name: 'tools' },
                { name: 'community' },
                { name: 'resources' },
                { name: 'marketing' },
            ],
            selected: null,
            tools: [
                {
                    name: 'OverlapPro',
                    url: 'https://overlappro.com',
                    img: 'overlappro_js',
                },
                {
                    name: 'SprinklerChart',
                    url: 'https://sprinklerchart.com',
                    img: 'sprinklerchart',
                },
                {
                    name: 'PivotMapper',
                    url: 'https://pivotmapper.com',
                    img: 'pivotmapper',
                },
                {
                    name: 'Plate Tool',
                    url: '/plate_tool',
                    img: 'plate_tool',
                },
                // {
                //     name: 'Territory Editor',
                //     url: '/territory_editor',
                //     img: 'nelson_logo',
                // }

            ],
            priceLists: [
                {
                    name: '2022 NIC Whole Goods Price List',
                    url: 'https:nelsonirrigation.com/portalresources/library/2022 NIC WHOLE GOODS PRICE LIST.pdf',
                    img: 'pdf',
                },
            ],
            selectedNum: 0,
            selectedNavButton: null,
            previousNavButton: null,
            subMenuOpen: false,
        };
    },
    getters: {
        getMenu () {
            return this.menu;
        },
        getLists () {
            return this.priceLists;
        },
        getTools () {
            return this.tools;
        },
        getSelectedNum () {
            return this.selectedNum;
        },
        getSelectedNavButton () {
            return this.selectedNavButton;
        },
        getPreviousNavButton () {
            return this.previousNavButton;
        },
        getSubMenuOpen () {
            return this.subMenuOpen;
        }
    },
    actions: {
        setSelectedNum (num) {
            this.selectedNum = num;
        },
        setSelectedNavButton (c) {
            this.selectedNavButton = c;
            this.previousNavButton = c;
        },
        setPreviousNavButton (c) {
            this.previousNavButton = c;
        },
        setSubMenuOpen (bool) {
            this.subMenuOpen = bool;
            if (!this.subMenuOpen) {
                this.selectedNavButton = null;
            }
        }
    }
});